import React from 'react';
import { useParams } from 'react-router-dom';
import useFetchAutoDGReportData from '../../Hooks/AutoDG/useFetchAutoDGReport';
import Download2Pdf from "../../common/Download2Pdf";
import Spinner from '../../common/Spinner';
import { formatValue } from '../../../utils/basic';
import { DataGrid } from "@material-ui/data-grid";

const AutoDGPlateReport = () => {

    const { plate_uuid } = useParams();
    const { data, isSuccess, isFetching, isError, error } = useFetchAutoDGReportData(plate_uuid);
    const plate_info = data?.data?.plate_info;// this is not a nested data object so no transformation needed, but it has unneedded keys 
    const plate_report = data?.data?.Plate_Report;

    // exclude the keys not necessary from plate_report object

    const excludeKeys = ["Total_wells"];

    // transform plate report to a format acceptable by the data grid

    const tranformedPlateReport = (plate_report, excludeKeys) => {
        return Object.entries(plate_report).reduce((acc, [key, value]) => {
            if (!excludeKeys.includes(key)) {
                if (value && typeof value === "object" && 'Value' in value && 'pass' in value) {

                    acc[key] = value?.Value;
                    acc[`${key} status`] = value?.pass;
                } else {
                    acc[key] = value;
                }
            }
            return acc;
        }, {});
    };
    const plateData = plate_report ? tranformedPlateReport(plate_report, excludeKeys) : {};

    const dataForGrid = [{ ...plateData, ...plate_info }];

    const dataForPdf = [];

    // map the API data to readable format for the data grid    

    const rows = dataForGrid.map((item) => {
        // Iterate over each key-value pair in the 'item' object for pdf
        for (const [key, value] of Object.entries(item)) {
            if (key === "Platepass") {
                dataForPdf.push({ Statistic: key, passfailValue: value });

            } else {
                dataForPdf.push({ Statistic: key, ObservedValue: value });
            }
        }

        // Return the original row object for the data grid
        return {
            carryover_fam_polydispersity_percent: formatValue(item["Carryover FAM Polydispersity %"]),
            carryover_fam_polydispersity_percent_status: item["Carryover FAM Polydispersity % status"],
            event_count_cv: formatValue(item.Event_Count_CV),
            event_count_cv_status: item["Event_Count_CV status"],
            event_count_mean: formatValue(item.Event_Count_Mean),
            event_count_mean_status: item["Event_Count_Mean status"],
            auto_dg_sn: item.autodg_serial_number,
            plate_uuid: item.plate_uuid,
            upload_date: item.upload_date,
            failures: item.failed_wells,
            dg_plate_name: item.auto_dg_plate_name,
            reader_sn: item.reader_sn,
            platepass: item.Platepass,
            id: crypto.randomUUID()
        };
    });



    const cols = [
        {
            field: 'platepass',
            headerName: 'Status',
            description: 'Status',
            width: 250,
            renderCell: (params) => (
                <span className={`${params.row.platepass === 'Pass' ? 'leading-[25px] text-center border  border-custom-green bg-custom-green rounded-lg w-1/2 h-auto text-white font-bold' : 'leading-[25px] text-center border border-red-600 bg-red-600 rounded-lg w-auto h-auto text-white font-bold'}`}>
                    {params.value}
                </span>
            )
        },
        {
            field: 'auto_dg_sn',
            headerName: 'AutoDG SN',
            description: 'AutoDG SN',
            width: 250,
        },
        {
            field: 'dg_plate_name',
            headerName: 'Auto DG Plate Name',
            description: 'Auto DG Plate Name',
            width: 550,
        },
        {
            field: 'reader_sn',
            headerName: 'Reader Serial #',
            description: 'Reader Serial #',
            width: 350,
        },
        {
            field: 'failures',
            headerName: 'Failures',
            description: 'Failures',
            width: 150,
            renderCell: (params) => (
                <span className={`${params.row.failures > 0 ? 'text-red-500 font-bold' : ''}`}>
                    {params.value}
                </span>
            ),
        },
        {
            field: 'plate_uuid',
            headerName: 'Plate UUID',
            description: 'Plate UUID',
            width: 350,
        },
        {
            field: 'upload_date',
            headerName: 'Upload Date',
            description: 'Upload Date',
            width: 250,
        },

        {
            field: 'carryover_fam_polydispersity_percent',
            headerName: 'Carryover FAM Polydispersity %',
            description: 'Carryover FAM Polydispersity %',
            width: 300,
            renderCell: (params) => (
                <span className={`${params.row.carryover_fam_polydispersity_percent_status ? 'text-custom-green font-bold' : 'text-red-500 font-bold'}`}>
                    {params.value}
                </span>
            ),
        },

        {
            field: 'event_count_cv',
            headerName: 'Event Count CV',
            description: 'Event Count CV',
            width: 300,
            renderCell: (params) => (
                <span className={`${params.row.event_count_cv_status ? 'text-custom-green font-bold' : 'text-red-500 font-bold'}`}>
                    {params.value}
                </span>
            ),
        },
        {
            field: 'event_count_mean',
            headerName: 'Event Count Mean',
            description: 'Event Count Mean',
            width: 300,
            renderCell: (params) => (
                <span className={`${params.row.event_count_mean_status ? 'text-custom-green font-bold' : 'text-red-500 font-bold'}`}>
                    {params.value}
                </span>
            ),
        },

    ];



    return (
        <>
            {isFetching ? (
                <Spinner text="Fetching Data... Pls wait" />
            ) : isSuccess && rows?.length > 0 ? (
                <>
                    <div className="flex items-end p-5">
                        <div className="flex-grow"></div>
                        <Download2Pdf reportData={dataForPdf} autoDgSerialNum={plate_info?.autodg_serial_number} reportType="fixedCol" /> {/* Pass dataForPdf to PDF component */}
                        <span className="p-2"></span>
                    </div>
                    <DataGrid columns={cols} rows={rows} />
                </>
            ) : isError ? (
                <p>{error}</p>
            ) : null}
        </>
    );


}

export default AutoDGPlateReport;
